import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StationCardComponent } from "./station-card.component";
import { IonicModule } from "@ionic/angular";

@NgModule({
  declarations: [StationCardComponent],
  exports: [StationCardComponent],
  imports: [CommonModule, IonicModule],
})
export class StationCardModule {}
